import { Icon, IconProps } from './Icon';

interface CheckCircleIconProps extends IconProps {
  gradient?: {
    id: string;
    stops: { offset: string; color: string }[];
  };
}

export const CheckCircleIcon = ({ color = '#0098F0', gradient, ...props }: CheckCircleIconProps) => (
  <Icon
    {...props}
    viewBox="0 0 32 32"
  >
    <defs>
      {gradient && (
        <linearGradient
          id={gradient.id}
          x1="80%"
          y1="20%"
          x2="20%"
          y2="80%"
        >
          {gradient.stops.map((stop, index) => (
            <stop
              key={index}
              offset={stop.offset}
              stopColor={stop.color}
            />
          ))}
        </linearGradient>
      )}
      <mask
        id="mask0_5612_53806"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="32"
        height="32"
      >
        <rect
          width="32"
          height="32"
          fill="#D9D9D9"
        />
      </mask>
    </defs>
    <rect
      width="32"
      height="32"
      rx="16"
      fill="#FEFEFE"
    />
    <g mask="url(#mask0_5612_53806)">
      <path
        d="M14.0088 18.1481L11.435 15.6123C11.2219 15.3995 10.9926 15.2905 10.7469 15.2854C10.5015 15.2805 10.2673 15.3895 10.0442 15.6123C9.82141 15.8354 9.71 16.0736 9.71 16.3269C9.71 16.5803 9.82141 16.8185 10.0442 17.0415L13.1508 20.1481C13.4033 20.4004 13.6894 20.5265 14.0088 20.5265C14.3283 20.5265 14.6144 20.4004 14.8669 20.1481L21.9262 13.0888C22.139 12.8758 22.2479 12.64 22.2531 12.3815C22.2579 12.1233 22.149 11.8827 21.9262 11.6596C21.7031 11.4368 21.4713 11.3254 21.2308 11.3254C20.9903 11.3254 20.7585 11.4368 20.5354 11.6596L14.0088 18.1481ZM16.0027 30C14.0837 30 12.2733 29.6356 10.5715 28.9069C8.86974 28.1782 7.38026 27.1755 6.10308 25.8988C4.8259 24.6222 3.82269 23.1333 3.09346 21.4323C2.36449 19.7313 2 17.9214 2 16.0027C2 14.0581 2.36436 12.2413 3.09308 10.5523C3.82179 8.86333 4.82449 7.38026 6.10115 6.10308C7.37782 4.8259 8.86667 3.82269 10.5677 3.09346C12.2687 2.36449 14.0786 2 15.9973 2C17.9419 2 19.7587 2.36436 21.4477 3.09308C23.1367 3.82179 24.6197 4.82449 25.8969 6.10115C27.1741 7.37782 28.1773 8.86026 28.9065 10.5485C29.6355 12.2367 30 14.0529 30 15.9973C30 17.9163 29.6356 19.7267 28.9069 21.4285C28.1782 23.1303 27.1755 24.6197 25.8988 25.8969C24.6222 27.1741 23.1397 28.1773 21.4515 28.9065C19.7633 29.6355 17.9471 30 16.0027 30Z"
        fill={gradient ? `url(#${gradient.id})` : color}
      />
    </g>
  </Icon>
);
